export type ExamDatesForLocationDto = {
  location: string;
  locationId: number;
  dates: ExamDatesForLocationItem[];
  isEditable: boolean;
};

export type ExamDatesForLocationItem = {
  date: Date;
  active: boolean;
  action: ActionEnum;
};

export enum ActionEnum {
  None = 1,
  Added = 2,
  Deleted = 3,
}
